import React from 'react'
import {
  Container,
  HeaderContent,
  ParagraphContent,
  ClockIllustration,
} from './commons/components'
import ActionButtons from './commons/action-buttons'
import PropTypes from 'prop-types'

export default function AccountTakeover({
  firstName = '',
  lastName = '',
  country = '',
  recipient = '',
  displayName = '',
  onConfirm,
  onCancel,
  variant,
}) {
  return (
    <Container>
      <ClockIllustration />
      <HeaderContent
        variant={variant}
        recipient={recipient}
        displayName={displayName}
      />
      <ParagraphContent
        variant={variant}
        firstName={firstName}
        lastName={lastName}
        country={country}
      />
      <ActionButtons onConfirm={onConfirm} onCancel={onCancel} />
    </Container>
  )
}

AccountTakeover.propTypes = {
  recipient: PropTypes.string,
  displayName: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  country: PropTypes.string,
  variant: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}
